import { Language } from "@/common/utils/constants";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Eq_AppBar from "../eqAppBar/EQ_AppBar";

const MainNavigation: React.FC = () => {
  const { i18n } = useTranslation();
  const logoText = i18n.language === Language.en ? "EN" : "FR";

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Eq_AppBar
      rightText={i18n.language === Language.en ? "LangFr" : "LangEn"}
      rightTextColor="iconWhite"
      logoOrientation={"horizontal"}
      logoText={true}
      logoTextLang={logoText}
    />
  );
};

export default MainNavigation;
